"use strict";
/**
 * @description: 设备检测相关
 * @author: fanzelong
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIOS = exports.isMobile = exports.isWeChatBrowser = exports.isLocal = exports.isNewTBC = exports.checkSupportAccountMobileSDK = exports.isOldIOSMobileClient = exports.isOldAndroidMobileClient = exports.isTBC = exports.isXdas = exports.isXlMac = exports.checkIsXlx = exports.isXl9 = exports.isEdge = void 0;
// ua标志
var ua = navigator.userAgent.toLocaleLowerCase();
var windowAny = window;
// Edge浏览器标志
var isEdgeFlag = undefined;
// UE版迅雷9和UE版迅雷X判断标志
var isXl9Flag = undefined;
// 迅雷X的TBC浏览器判断标志
var isXlxFlag = undefined;
// 迅雷Mac的内嵌浏览器判断标志
var isXlMacFlag = undefined;
// XDAS平台判断标志
var isXDASFlag = undefined;
// TBC浏览器判断标志
var isTBCFlag = undefined;
// 是否为旧安卓手机客户端
var isOldAndroidMobileClientFlag = undefined;
// 是否为旧ios手机客户端
var isOldIOSMobileClientFlag = undefined;
// 是否支持新account mobile sdk
var isSupportAccountMobileSDKFlag = undefined;
// 是否为本地页面
var isLocalFlag = undefined;
// 是否为微信内嵌浏览器
var isWeChatBrowserFlag = undefined;
// 是否为移动端
var isMobileFlag = undefined;
// 是否为iOS
var isIOSFlag = undefined;
/**
 * @description 判断是否为Edge浏览器
 * @return {boolean}
 */
function isEdge() {
    if (isEdgeFlag === undefined) {
        isEdgeFlag = /\bedge\b/.test(ua);
    }
    return isEdgeFlag;
}
exports.isEdge = isEdge;
/**
 * @description 判断是否UE版迅雷9和UE版迅雷X
 * @return {boolean}
 */
function isXl9() {
    // 因历史原因，此处的isXl9标志其实是UE版迅雷9和UE版迅雷X判断标志
    if (isXl9Flag === undefined) {
        isXl9Flag =
            /[ ]thunder\/10.0([\d.]*)/.test(ua) ||
                /[ ]thunder( )?\/( )?9.([\d.]*)/.test(ua);
    }
    return isXl9Flag;
}
exports.isXl9 = isXl9;
/**
 * @description 判断是否为迅雷X的TBC浏览器
 * @return {boolean}
 */
function checkIsXlx() {
    // /[ ]thunder\/10.1([\d.]*)/.test(ua)是匹配了迅雷X的10.1的及以上版本
    // (!/thunder/.test(ua) && !!window.native)是为了适配早期迅雷X版本，判断有问题，此处直接去掉
    if (isXlxFlag === undefined) {
        isXlxFlag = /\bthunder\/10.[1-9][\d.]*/.test(ua);
    }
    return isXlxFlag;
}
exports.checkIsXlx = checkIsXlx;
/**
 * @description 判断是否为mac迅雷的内嵌浏览器
 * @return {boolean}
 */
function isXlMac() {
    if (isXlMacFlag === undefined) {
        isXlMacFlag = /\bmac\b/.test(ua) && !!windowAny.WebViewJavascriptBridge;
    }
    return isXlMacFlag;
}
exports.isXlMac = isXlMac;
/**
 * @description 判断是否为XDAS平台
 * @return {boolean}
 */
function isXdas() {
    // XDAS平台判断标志，使用electron标志来判断，即(/\belectron\/\d+(\.\d+){2}\b/.test(ua))
    if (isXDASFlag === undefined) {
        isXDASFlag = /\belectron\/\d+(\.\d+){2}\b/.test(ua);
    }
    return isXDASFlag;
}
exports.isXdas = isXdas;
/**
 * @description 判断是否为TBC浏览器
 * @return {boolean}
 */
function isTBC() {
    if (isTBCFlag === undefined) {
        isTBCFlag = /\btbc\/\d+(\.\d+){3}\b/.test(ua) && !!windowAny.native;
    }
    return isTBCFlag;
}
exports.isTBC = isTBC;
/**
 * @description 判断是否为旧安卓客户端
 * @return {boolean}
 */
function isOldAndroidMobileClient() {
    if (isOldAndroidMobileClientFlag === undefined) {
        if (isOldIOSMobileClient()) {
            isOldAndroidMobileClientFlag = false;
        }
        else if (typeof windowAny.XLJSWebViewBridgeExport != 'undefined') {
            isOldAndroidMobileClientFlag = true;
        }
        else if (typeof windowAny.XLJSWebViewBridge !== 'undefined') {
            isOldAndroidMobileClientFlag = true;
        }
        else {
            isOldAndroidMobileClientFlag = false;
        }
    }
    return isOldAndroidMobileClientFlag;
}
exports.isOldAndroidMobileClient = isOldAndroidMobileClient;
/**
 * @description 判断是否为旧ios手机客户端
 * @return {boolean}
 */
function isOldIOSMobileClient() {
    if (isOldIOSMobileClientFlag === undefined) {
        if (typeof windowAny.webkit != 'undefined' &&
            typeof windowAny.webkit.messageHandlers &&
            typeof windowAny.webkit.messageHandlers.XLJSWebViewBridgeExport !=
                'undefined') {
            isOldIOSMobileClientFlag = true;
        }
        else if (typeof windowAny.webkit != 'undefined' &&
            typeof windowAny.webkit.messageHandlers &&
            typeof windowAny.webkit.messageHandlers.XLJSWebViewBridge != 'undefined') {
            isOldIOSMobileClientFlag = true;
        }
        else {
            isOldIOSMobileClientFlag = false;
        }
    }
    return isOldIOSMobileClientFlag;
}
exports.isOldIOSMobileClient = isOldIOSMobileClient;
/**
 * 检测是否支持新account mobile sdk
 * @return {boolean}
 */
function checkSupportAccountMobileSDK() {
    if (isSupportAccountMobileSDKFlag === undefined) {
        isSupportAccountMobileSDKFlag =
            typeof windowAny.XLAccountJsBridge !== 'undefined';
    }
    return isSupportAccountMobileSDKFlag;
}
exports.checkSupportAccountMobileSDK = checkSupportAccountMobileSDK;
/**
 * @description 判断是否为新tbc浏览器(windows版客户端的内嵌浏览器)
 * @return {boolean}
 */
function isNewTBC() {
    // UE版迅雷9和UE版迅雷X为旧版的tbc浏览器
    return checkIsXlx() || (!isXl9() && isTBC());
}
exports.isNewTBC = isNewTBC;
/**
 * @description 判断是否为本地页面
 * @return {boolean}
 */
function isLocal() {
    if (isLocalFlag === undefined) {
        isLocalFlag = location.protocol === 'file:';
    }
    return isLocalFlag;
}
exports.isLocal = isLocal;
/**
 * 检查是否为微信内嵌浏览器
 * @return {boolean}
 */
function isWeChatBrowser() {
    if (isWeChatBrowserFlag === undefined) {
        isWeChatBrowserFlag = /micromessenger/i.test(ua);
    }
    return isWeChatBrowserFlag;
}
exports.isWeChatBrowser = isWeChatBrowser;
/**
 * 是否为移动端
 * @return {boolean}
 */
function isMobile() {
    if (isMobileFlag === undefined) {
        isMobileFlag = /mobile|android|iphone|ipad|iemobile/i.test(ua);
    }
    return isMobileFlag;
}
exports.isMobile = isMobile;
/**
 * 是否为iOS
 * @return {boolean}
 */
function isIOS() {
    if (isIOSFlag === undefined) {
        isIOSFlag = isMobile() && /iphone|ipad|ipod|ios/i.test(ua);
    }
    return isIOSFlag;
}
exports.isIOS = isIOS;
//# sourceMappingURL=device-check.js.map